import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const QueryService = {
  actions: {
    fetchQuery ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query/' + id,
          method: 'GET'
        })
          .then(resp => {
            const query = resp.data.query
            commit('api_success')
            resolve(resp)
            return query
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchAllQueries ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/queries',
          method: 'GET'
        })
          .then(resp => {
            const queries = resp.data.queries
            commit('api_success')
            resolve(resp)
            return queries
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    deleteQuote ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query/' + id,
          method: 'DELETE'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  }
}

export default QueryService



// WEBPACK FOOTER //
// ./src/services/queryService.js